import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Route guard for Civil-vertical-only pages (e.g. RCR-Layout).
 *
 * Stricter than the cricket-dashboard route, which is open to any
 * authenticated user. Used where the page writes per-user data and a
 * non-Civil user must not be allowed to create it via deep link.
 *
 * Accepts both 'Civil' (current User enum) and 'Civil Construction'
 * (legacy data — Sidebar.js does the same defensive check).
 */
const CivilRouteGuard = ({ children }) => {
  const { user } = useAuth();
  const isCivil = user?.vertical === 'Civil' || user?.vertical === 'Civil Construction';
  if (!isCivil) return <Navigate to="/dashboard" replace />;
  return children;
};

export default CivilRouteGuard;
